import { render, staticRenderFns } from "./selectMaterial.vue?vue&type=template&id=2e1f2199&"
import script from "./selectMaterial.vue?vue&type=script&lang=js&"
export * from "./selectMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports